export enum LeadGenField {
  NAME = "name",
  FIRST_NAME = "first-name",
  LAST_NAME = "last-name",
  BUSINESS_EMAIL = "business-email",
  PHONE = "phone",
  COMPANY_NAME = "company-name",
  PACKAGING_UNITS_NEEDED_PER_YEAR = "packaging-units-needed-per-year",
  PRODUCT_ID = "product-id",
  PRODUCT_VERSION_ID = "product-version-id",
  PRODUCT = "product",
  PRESET = "preset",
  QUANTITY = "quantity",
  SIZE = "size",
  CUSTOM_SIZE = "custom-size",
  JOB_TITLE = "job-title",
}
